
import Form from './_.extend';
import stores from "../models/index";
import VideoModel from "../models/VideoModel";

const getDefaultVideoExpiry = () => {
    var date = new Date();    
    date.setMonth(date.getMonth() + 2);
    return date;
};

const yesNoOptions = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' }
];

export default class VideoForm extends Form {

    constructor() {        
        super({
            fields: {
                name: {
                    label: 'Video Name',
                    rules: 'required|string|between:4,255'
                },
                url: {
                    label: 'Video URL',
                },                
                clusters: {
                    label: 'Clusters',
                    rules: 'required',
                    observers: [{
                        key: 'value',
                        call: ({ form, field, change }) => {
                            if (change.newValue !== '') {
                                let allOption = change.newValue.filter(field => field.value === 'ALL');
                                if (allOption.length > 0) {
                                    let allClusters = stores.clusterStore.ClusterOptions.filter(field => field.disabled !== true && field.value !== 'ALL')
                                    field.value = allClusters;
                                }
                            }                            
                        },
                    }]
                },
                releasedate: {
                    label: 'Release Date',
                    rules: 'required',
                    value: new Date(),
                    extra: { min: (window !== undefined && window.location.search.match('showall') === null) ? new Date() : new Date(0) } // disable min date for testing purpose

                },
                expirydate: {
                    label: 'Expiry Date',
                    rules: 'required',
                    value: getDefaultVideoExpiry(),
                    extra: { min: (window !== undefined && window.location.search.match('showall') === null) ? new Date() : new Date(0) } // disable min date for testing purpose

                },
                enabled: {
                    label: 'Enabled',                    
                    value: yesNoOptions[0],
                    extra: yesNoOptions
                },
                manageronly: {
                    label: 'Managers Only',
                    value: yesNoOptions[1],
                    extra: yesNoOptions
                }
            }
        }, { name: 'Video' });        
    }

    hooks() {
        return {
            onSuccess(form) {
                //alert('Form is valid! Send the request here.');
                // get field values
                console.log('Form Values!', form.values());

                var formData = form.values();                                 
                var newVideo = new VideoModel(null, formData.name, formData.url, formData.clusters, formData.expirydate, formData.releasedate, formData.enabled.value, formData.manageronly.value);
                stores.videoStore.addVideo(newVideo);                                               

                form.reset(true);
                form.hide();
            },
            onError(form) {
                // get all form errors      
                let errorMessage = '', errors = form.errors();
                for (let field in errors) {
                    if (errors[field] !== null)
                        errorMessage += errors[field] + '\n';
                }
                alert(errorMessage);
            }
        };
    }
}


// WEBPACK FOOTER //
// ./src/forms/VideoForm.js